import { Component, OnInit, Inject } from '@angular/core';
import { InterpretationService } from '../../interpretation.service';
import { NotificationsService } from 'angular2-notifications';
import { RecommendationTypeModel, AddRecommendationModel, SeverityTypeModel } from '../../models/interpretation.model';
import { FormGroup, FormBuilder, Validators } from '@angular/forms';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';

@Component({
  selector: 'add-recommendation',
  templateUrl: './add-recommendation.component.html',
  styleUrls: ['./add-recommendation.component.scss']
})
export class AddRecommendationComponent implements OnInit {
  inspectionId: number;
  quoteId: number;
  componentId: number;

  loadingPossibleRecommendations = true;
  possibleRecommendations: RecommendationTypeModel[] = [];
  SeverityDropDownList: SeverityTypeModel[] = [];
  recommendation: number;
  severityId: number;
  comment: string;
  labourCost = 0;
  partsCost = 0;
  miscCost = 0;
  smuToTakeAction: number
  smuToCompleteActionBy: number = 0;

  form: FormGroup;
  savingForm = false;
  actionDate: Date;



  constructor(private _dialogRef: MatDialogRef<AddRecommendationComponent>,
    @Inject(MAT_DIALOG_DATA) private _data: any,
    private _interp: InterpretationService,
    private _notify: NotificationsService,
    private _fb: FormBuilder) { }

  ngOnInit() {
    this.inspectionId = this._data.inspectionId;
    this.quoteId = this._data.quoteId;
    this.componentId = this._data.componentId;
    if (this._data.inspectionSMU !== undefined) {
      this.smuToTakeAction = this._data.inspectionSMU;
    }

    //localStorage.clear(); // use remove local storage

    this.getPossibleRecommendations();
    this.getSeverityDropdown();
    this.form = this._fb.group({
      'recommendation': [0,Validators.required],
      'smuToTakeAction': [this.smuToTakeAction],
      'smuToCompleteActionBy': [this.smuToCompleteActionBy],
      'labourCost': [this.labourCost],
      'partsCost': [this.partsCost],
      'miscCost': [this.miscCost ],
      'comment': '',
      'actionDate': [this.actionDate, Validators.required],
      'severityId':  [this.severityId, Validators.required],
    });
  }

  closeModal() {
    this._dialogRef.close();
  }

  // onSubmit(form, isForBothSides = false) {
  //   if (form.recommendation < 1)
  //     return;

  //   console.log(form);

  //   this.savingForm = true;
  //   const rec = new AddRecommendationModel();
  //   rec.ActionId = form.recommendation;
  //   rec.Comment = form.comment;
  //   rec.ComponentId = this.componentId;
  //   rec.InspectionId = this.inspectionId;
  //   rec.QuoteId = this.quoteId;
  //   rec.LabourCost = form.labourCost;
  //   rec.PartsCost = form.partsCost;
  //   rec.MiscCost = form.miscCost;
  //   rec.SmuToCompleteActionBy = form.smuToTakeAction + form.smuToCompleteActionBy;
  //   rec.SmuToTakeAction = form.smuToTakeAction;
  //   rec.AddedForBothSide = isForBothSides;
  //   this._interp.addRecommendation(rec).subscribe(r => {
  //     if (r.m_Item1 > 0) {
  //       this._notify.success('Added', r.m_Item3);
  //       this._dialogRef.close({
  //         quoteId: r.m_Item1,
  //         recommendationId: r.m_Item2
  //       });
  //     } else {
  //       this._notify.error('Failed', r.m_Item3);
  //       console.error(r.m_Item2);
  //     }
  //     this.savingForm = false;
  //   }, error => {
  //     this._notify.error('Error', 'Unable to add the recommendation. Please contact TrackTreads support. ');
  //     console.error(error);
  //     this.savingForm = false;
  //   });
  // }


  checkValidation(value: boolean) {
    debugger;
    if ( this.recommendation == null ||this.actionDate == null || this.severityId == null) {
      this.savingForm = false;
    }
    else {
      this.savingForm = true;
      this.onSubmit(value)
    }
  }

  // checkValidation(value: boolean) {
  //   if (this.recommendation == 0 || this.recommendation == null ||
  //     this.labourCost == null || this.partsCost == null
  //     || this.miscCost == null || this.smuToTakeAction == null || this.actionDate == null) {
  //     this.savingForm = false;
  //   }
  //   else {
  //     this.savingForm = true;
  //     this.onSubmit(value)
  //   }
  // }
  //new code

  // how about shit code?
  onSubmit(isForBothSides: boolean) {
    debugger;
    //console.log("isForBothSides",isForBothSides)
    if (this.recommendation < 1)
      return;
    this.savingForm = true;
    const rec = new AddRecommendationModel();
    rec.ActionId = this.recommendation;
    rec.Comment = this.comment;
    rec.ComponentId = this.componentId;
    rec.InspectionId = this.inspectionId;
    rec.QuoteId = this.quoteId;
    rec.LabourCost = this.labourCost;
    rec.PartsCost = this.partsCost;
    rec.MiscCost = this.miscCost;
    rec.SmuToCompleteActionBy = this.smuToTakeAction + this.smuToCompleteActionBy;
    rec.SmuToTakeAction = this.smuToTakeAction;
    rec.AddedForBothSide = isForBothSides;
    rec.ActionDate = this.actionDate;
    rec.SeverityId =this.severityId
    this._interp.addRecommendation(rec).subscribe(r => {
      if (r.m_Item1 > 0) {
        this._notify.success('Added', r.m_Item3);
        this._dialogRef.close({
          quoteId: r.m_Item1,
          recommendationId: r.m_Item2
        });
      } else {
        this._notify.error('Failed', r.m_Item3);
        console.error(r.m_Item2);
      }
      this.savingForm = false;
    }, error => {
      this._notify.error('Error', 'Unable to add the recommendation. Please contact TrackTreads support. ');
      console.error(error);
      this.savingForm = false;
    });
  }
  getPossibleRecommendations() {
    this._interp.getPossibleRecommendations(this.inspectionId, this.componentId).subscribe(rec => {
      this.possibleRecommendations = rec;
      this.loadingPossibleRecommendations = false;
    }, err => {
      this._notify.error('Error', 'Unable to load possible recommendations. Please contact TrackTreads support. ');
      console.error(err);
    });
  }

  getSeverityDropdown() {
    this._interp.getSeverityDropdown(this.inspectionId).subscribe(rec => {
      this.SeverityDropDownList = rec;
      this.loadingPossibleRecommendations = false;
    }, err => {
      this._notify.error('Error', 'Unable to load possible recommendations. Please contact TrackTreads support. ');
      console.error(err);
    });
  }


  submitForBothSides() {
    this.checkValidation(true);
  }
  submit() {
    this.checkValidation(false);
  }
}
